// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"bc6cc02a","383":"31b446c7","453":"0ad8c500","563":"3595309d","678":"90c9db26","868":"d0ddac6d","915":"bf8495e0"}[chunkId] + ".chunk.js";
};